/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import {LOG_USER_OUT_ACTION} from "@Actions/Authentication";


import ApplicationRouterContext from "@Contexts/Router";
import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";


import {Col} from "react-bootstrap";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";


import SessionEndingCommunicateComponent from "@Components/UI/Communicates/Session";

import BottomBarMenuInterface from "@UIParts/BarBottom/_Interfaces/Menu";
import BottomBarElementComponent from "@UIParts/BarBottom/Element";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";


import startMenuIcon from "@Icons/Menu/start.png";
import startMenuActiveIcon from "@Icons/Menu/start_active.png";
import dispositionsMenuIcon from "@Icons/Menu/dispositions.png";
import dispositionsMenuActiveIcon from "@Icons/Menu/dispositions_active.png";
import monitoryNotesMenuIcon from "@Icons/Menu/monitory_notes.png";
import monitoryNotesMenuActiveIcon from "@Icons/Menu/monitory_notes_active.png";
import terminalsMenuIcon from "@Icons/Menu/terminals.png";
import terminalsMenuActiveIcon from "@Icons/Menu/terminals_active.png";
import moreMenuIcon from "@Icons/Menu/more.png";
import moreMenuActiveIcon from "@Icons/Menu/more_active.png";


type BottomBarComponentProps = {location: any};


export const ApplicationBottomBarComponent: React.FC<BottomBarComponentProps> = ({location}): JSX.Element | null => {


    const DISPATCHER = useDispatch();


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [SESSION_ACTIVE_TIME, SET_SESSION_ACTIVE_TIME] = useState<number>(REST_API_REQUEST_TOKEN?.tokenValidTime || 0);
    const [SESSION_END_TIME, SET_SESSION_END_TIME] = useState<number>(Date.now() + SESSION_ACTIVE_TIME * 1000);
    const [ACTIVE_SESSION_TIMEOUT, SET_ACTIVE_SESSION_TIMEOUT] = useState<any>(null);

    useEffect(() => {
        if (SESSION_ACTIVE_TIME > 0) {
            if (ACTIVE_SESSION_TIMEOUT) window.clearTimeout(ACTIVE_SESSION_TIMEOUT);
            const COUNTDOWN = setTimeout(
                () => SET_SESSION_ACTIVE_TIME(Math.floor( (SESSION_END_TIME - Date.now())/1000 )), 1000
            );
            SET_ACTIVE_SESSION_TIMEOUT(COUNTDOWN);
        } else {
            DISPATCHER(LOG_USER_OUT_ACTION());
        }
    }, [SESSION_ACTIVE_TIME]);

    useEffect(() => {
        if (SESSION_ACTIVE_TIME === 0) return;
        SET_SESSION_ACTIVE_TIME(REST_API_REQUEST_TOKEN.tokenValidTime || 0);
        SET_SESSION_END_TIME(Date.now() + (REST_API_REQUEST_TOKEN.tokenValidTime || 0) * 1000);
    }, [REST_API_REQUEST_TOKEN?.tokenValue]);


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    if (!LOGGED_USER || !LOGGED_USER?.userID || !ROUTER) return null;


    const HOME_PAGE_URL: string = ROUTER.AUTHENTICATED.HOME.URL;
    const MONITORY_NOTES_URL: string = ROUTER.AUTHENTICATED.MONITORY_NOTES.MONITORY_NOTES_LIST.URL;
    const DISPOSITIONS_URL: string = ROUTER.AUTHENTICATED.DISPOSITIONS.DISPOSITIONS_TERMINALS_LIST.URL;
    const PETROL_BASES_URL: string = ROUTER.AUTHENTICATED.PETROL_BASES.PETROL_BASES_LIST.URL;
    const SETTINGS_PAGE_URL: string = ROUTER.AUTHENTICATED.SETTINGS.MAIN_PAGE.URL;


    const BottomBarMenu:BottomBarMenuInterface = {
        startMenuElement: {menuElementURL: HOME_PAGE_URL || "/", menuElementText: "Start", menuElementTitle: "Strona Główna", menuElementIcon: startMenuIcon, menuElementActiveIcon: startMenuActiveIcon, menuElementExactStatus: true, location: location},
        dispositionsMenuElement: {menuElementURL: DISPOSITIONS_URL || "/", menuElementText: "Dyspozycje", menuElementTitle: "Twoje Dyspozycje", menuElementIcon: dispositionsMenuIcon, menuElementActiveIcon: dispositionsMenuActiveIcon, location: location},
        monitoryNotesElement: {menuElementURL: MONITORY_NOTES_URL || "/", menuElementText: "Awizacje", menuElementTitle: "Twoje Awizacje", menuElementIcon: monitoryNotesMenuIcon, menuElementActiveIcon: monitoryNotesMenuActiveIcon, location: location},
        terminalsElement: {menuElementURL: PETROL_BASES_URL || "/", menuElementText: "Bazy Paliw", menuElementTitle: "Twoje Bazy Paliw", menuElementIcon: terminalsMenuIcon, menuElementActiveIcon: terminalsMenuActiveIcon, location: location},
        moreOptionsElement: {menuElementURL: SETTINGS_PAGE_URL || "/", menuElementText: "Więcej", menuElementTitle: "Więcej opcji", menuElementIcon: moreMenuIcon, menuElementActiveIcon: moreMenuActiveIcon, location: location}
    };


    const BottomBarMenuElements = Object.values(BottomBarMenu).map((element) =>
        <BottomBarElementComponent key={element.menuElementURL} {...element} />
    );


    return (
        <BlockContentContainerComponent as={"nav"} cssClasses={"bottom-menu-bar-component"}>

            {SESSION_ACTIVE_TIME < 60 &&
	        <SessionEndingCommunicateComponent LEFT_SESSION_TIME={SESSION_ACTIVE_TIME}/>
            }

            <Col xs={12} as={"ul"} className={"bottom-menu-bar"}>
                {BottomBarMenuElements}
            </Col>

        </BlockContentContainerComponent>
    );

};


export default ApplicationBottomBarComponent;
